export enum NumberConditionOperators {
  BETWEEN = "between",
  LESS_OR_EQUAL = "less-or-equal",
  MORE_OR_EQUAL = "more-or-equal",
  EQUAL = "equal"
}
